// aiModal.js

import axios from "axios";
import { BASEURL } from "./api";

// const BASE_CHAT_URL = 'https://api.openai.com/v1/chat/completions';
// const BASE_FILE_UPLOAD_URL = 'https://api.openai.com/v1/files';
// const apiKey=process.env.REACT_APP_OPENAI_API_KEY;


export const callAiModal = async (messages, role) => {
  try {
    const reply = await axios.post(`${BASEURL}/api/openAI/chats`, {
      messages, role
    });
    return reply?.data?.data || "No assistant reply found.";
  }
  catch (e) {
    return "No assistant reply found."
  }
}



// export const uploadFileToOpenAI = async (file) => {
//   const formData = new FormData();
//   formData.append('file', file);
//   formData.append('purpose', 'assistants'); // Required for GPT-4-turbo

//   const response = await fetch(BASE_FILE_UPLOAD_URL, {
//     method: 'POST',
//     headers: {
//       Authorization: `Bearer ${apiKey}`,
//     },
//     body: formData,
//   });

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.error?.message || 'File upload failed.');
//   }

//   const data = await response.json();
//   return data.id; // This is the file_id
// };


// export const callAiModalWithFile = async (messages, fileId,aiModalPrompt) => {
//   try {
//     const response = await fetch(BASE_CHAT_URL, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${apiKey}`,
//       },
//       body: JSON.stringify({
//         model: 'gpt-4-turbo',
//         messages: [
//           {
//             role: 'system',
//             content:aiModalPrompt,
//           },
//           ...messages,
//         ],
//         tools: [{ type: 'code_interpreter' }],
//         tool_choice: 'auto',
//         file_ids: [fileId],
//         temperature: 0.3,
//       }),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.error.message || 'Something went wrong');
//     }

//     const data = await response.json();
//     return data?.choices?.[0]?.message?.content || 'No response found.';
//   } catch (error) {
//     console.error('AI Modal Error:', error.message);
//     return `Error: ${error.message}`;
//   }
// };
